export default {"src":"/_next/static/media/globe.480aaa4b.svg","height":14,"width":14};